import { applyMiddleware, configureStore } from '@reduxjs/toolkit'
import { createLogger } from 'redux-logger';
import { thunk } from 'redux-thunk';
import CommonReducer from './reducers/CommonReducer.js'
import UUMReducer from './reducers/UUMReducer.js';
import SIPReducer from './reducers/SIPReducer.js';
import OxeReducer from './reducers/OxeReducer.js';
import ProgKeysReducer from './reducers/ProgKeysReducer.js';

const logger = createLogger();
const middleware = applyMiddleware(thunk, logger);
const reducer = {
  common: CommonReducer,
  uum: UUMReducer,
  sip: SIPReducer,
  oxe: OxeReducer,
  progkeys: ProgKeysReducer
}

export default configureStore({ reducer }, middleware, logger)